'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespaceCompat(e) {
    if (e && typeof e === 'object' && 'default' in e) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceCompat(React);

const Svg24 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 24, height: 25, viewBox: "0 0 24 25", fill: "none" }, props),
    React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.436 7.308a1.2 1.2 0 0 0-.128 1.693l9.062 10.54.031.035c.148.172.33.385.513.545.221.194.595.452 1.125.452.529 0 .903-.258 1.124-.451.183-.16.365-.374.513-.546l.03-.035 8.985-10.45a1.2 1.2 0 0 0-1.82-1.565L12.04 17.8 3.129 7.436a1.2 1.2 0 0 0-1.693-.128", fill: props.fillColor, fillOpacity: 0.92 })));

exports.default = Svg24;
//# sourceMappingURL=24.js.map
